/* eslint-disable */
import React, { useState } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import l1 from '../../assets/emojis/lungs1.png';
import gut from '../../assets/emojis/gut.webp';

function Page() {
  const additionalGoals = useStore((state) => state.additionalGoals);
  const setAdditionalGoals = useStore((state) => state.setAdditionalGoals);
  const [next, setNext] = useState(additionalGoals.length > 0);

  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value: string) => {
    setAdditionalGoals(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.additionalGoals.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={additionalGoals} onChange={handleChange}>
          <MultiOption value={'Build healthy relationship with food'}>
            <span>🥦</span> {t('onboarding.additionalGoals.options.relationshipWithFood')}
          </MultiOption>
          <MultiOption value={'Improve overall wellbeing'}>
            <span>❤️</span> {t('onboarding.additionalGoals.options.wellbeing')}
          </MultiOption>
          <MultiOption value={'Boost daily energy'}>
            <span>🔋</span> {t('onboarding.additionalGoals.options.energy')}
          </MultiOption>
          <MultiOption value={'Improve gut health'}>
            <img className='emoji' src={gut} alt='gut' />
            {t('onboarding.additionalGoals.options.gutHealth')}
          </MultiOption>
          <MultiOption value={'Feel better about myself'}>
            <span>👌</span> {t('onboarding.additionalGoals.options.feelBetter')}
          </MultiOption>
          <MultiOption value={'Improve sport performance'}>
            <span>👟</span> {t('onboarding.additionalGoals.options.sportPerformance')}
          </MultiOption>
          <MultiOption value={'Reduce stress'}>
            <span>🤯</span> {t('onboarding.additionalGoals.options.reduceStress')}
          </MultiOption>
          <MultiOption value={'Learn more about nutrition'}>
            <img className='emoji' src={l1} alt='lungs' />
            {t('onboarding.additionalGoals.options.nutrition')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.additionalGoals.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'additional-goals',
              answer: additionalGoals.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
